import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowDropDownCircleIcon from "@mui/icons-material/ArrowDropDownCircle";
import ReactLoading from "react-loading";
import "./style.css";
import {
  Box,
  Typography,
  Grid,
  FormHelperText,
  FormLabel,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  InputAdornment,
  Autocomplete,
  TextField,
  Chip,
} from "@mui/material";
import { useFormik } from "formik";
import * as yup from "yup";
import CustomTextField from "../../Components/TextField";
import { useDispatch, useSelector } from "react-redux";
import {
  activeExploreCategory,
  CLEAR_EXPLORE_DATA,
  CLEAR_EXPLORE_SUCCESS,
  previewExploreDataAction,
} from "../../Redux/Actions/ExploreAction";
import HelmetReact from "../../Components/Helmet";
import useToggle from "../../hooks/use-toggle";
import MyEditor from "../../Components/MyEditor";

const CreateContent = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [coverImagePreview, setCoverImagePreview] = useState("");
  const [contentImagePreview, setContentImagePreview] = useState("");
  const [navigateRoute, setNavigateRoute] = useState("SANDBOX");
  const fileInputRef1 = useRef(null);
  const fileInputRef2 = useRef(null);
  const [editForm, setEditForm] = useState(false);
  const { exploreDetail, isEdit, exploreCategoryList, loading, success } =
    useSelector((state) => state.Explore);
  const [keywordsValues, setkeywordsValues] = useState([]);
  const ITEM_HEIGHT = 48;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5,
      },
    },
  };
  const goBack = () => {
    dispatch({ type: CLEAR_EXPLORE_SUCCESS });
    navigate("/explore", { state: navigateRoute });
    setEditForm(false);
  };
  const [categoryList, setCategoryList] = useState([]);

  const [inputValue, setInputValue] = useState("");

  const handleOnChange = (event, newValue) => {
    setkeywordsValues(newValue);
  };

  const handleInputChange = (event, newInputValue) => {
    setInputValue(newInputValue);
  };
  const handleDelete = (value) => {
    let newValues = [];
    newValues = keywordsValues.filter((text) => text !== value);
    setkeywordsValues(keywordsValues.filter((text) => text !== value));

    formik.setFieldValue("keywords", newValues);
  };

  const handleKeyPress = (event, index) => {
    if (event.key === "Enter") {
      setkeywordsValues([...keywordsValues, inputValue]);
      setInputValue("");
      formik.setFieldValue("keywords", [...keywordsValues, inputValue]);
    } else if (event.key === "Backspace") {
      const newValues = [...keywordsValues];
      newValues.splice(-1);
      formik.setFieldValue("keywords", newValues);
    }
  };

  const formik = useFormik({
    initialValues: {
      Id: exploreDetail?.Id ? exploreDetail?.Id : "",
      title: exploreDetail?.title ? exploreDetail?.title : "",
      contributor_name: exploreDetail?.contributor_name
        ? exploreDetail?.contributor_name : "",
      category: isEdit && exploreDetail?.category?.id ? exploreDetail?.category?.id : exploreDetail?.category ? exploreDetail?.category : "",
      cover_img: exploreDetail?.cover_img ? exploreDetail?.cover_img : "",
      short_desc: exploreDetail?.short_desc
        ? exploreDetail?.short_desc : "",
      full_desc: exploreDetail?.full_desc ? exploreDetail?.full_desc : "",
      content_file: !isEdit ? exploreDetail?.content_file
        : exploreDetail?.content_file ? exploreDetail?.content_file : "",
      content_file_duration: exploreDetail?.content_file_duration
        ? exploreDetail?.content_file_duration : null,
      keywords: !isEdit ? exploreDetail?.keywords
        : isEdit && typeof exploreDetail?.keywords === "string"  ? JSON.parse(exploreDetail?.keywords) : 
        isEdit && typeof exploreDetail?.keywords === "object"  ? Object.values(exploreDetail?.keywords)
        : [],
    },
    validationSchema: yup.object({
      title: yup
        .string()
        .matches(
          /^\S.*/,
          "* This field cannot contain whitepaces at first letter"
        )
        .required("Content Title Required"),
      contributor_name: yup
        .string()
        .matches(
          /^\S.*/,
          "* This field cannot contain whitepaces at first letter"
        )
        .required("Contributor Name Required"),
      cover_img: yup
        .mixed()
        .required("A file is required")
        .test("fileFormat", "JPEG JPG AND PNG Files only", (value) => {
          const file = new File([value], "tempimage", {
            type: value?.type || "image/jpg",
          });
          return (
            !file ||
            (file &&
              ["image/jpeg", "image/png", "image/jpg"].includes(file.type))
          );
        }),
      category: yup.string().required("Category Required"),
      short_desc: yup
        .string()
        .matches(
          /^\S.*/,
          "* This field cannot contain whitepaces at first letter"
        )
        .required("Please Enter short_desc"),
      full_desc: yup
        .string()
        .matches(
          /^\S.*/,
          "* This field cannot contain whitepaces at first letter"
        )
        .required("Please Enter full Description"),
      content_file: yup
        .mixed()
        .required("A file is required")
        .test("fileFormat", "JPEG JPG PNG And VIDEO Files only", (value) => {
          const file = new File([value], "tempimage", {
            type: value?.type || "image/jpg" || value?.type || "video/mp4",
          });
          return (
            !file ||
            (file &&
              ["image/jpeg", "image/png", "image/jpg", "video/mp4"].includes(
                file.type
              ))
          );
        }),
      keywords: yup.array().min(1).of(yup.string().required()).required(),
    }),
    enableReinitialize: true,
    onSubmit: (values, { resetForm }) => {
      if (!isEdit) {
        setNavigateRoute("SANDBOX");
        dispatch(previewExploreDataAction(formik.values));
        navigate("/explore/create-content/preview");        
      } else {        
        dispatch(previewExploreDataAction(formik.values));
        setEditForm(false);
        navigate("/explore/create-content/preview");        
      }
    },
  });

  useEffect(() => {
    if (success && !loading) {
      navigate("/explore", { state: navigateRoute });
      dispatch({ type: CLEAR_EXPLORE_DATA });
    }
  }, [success]);
  useEffect(() => {    
    if (isEdit && typeof exploreDetail?.keywords === "string") {      
      setkeywordsValues(JSON.parse(exploreDetail?.keywords));
    }    
    typeof exploreDetail?.keywords !== "string" && setkeywordsValues(exploreDetail?.keywords ? exploreDetail?.keywords : "")
  }, [exploreDetail?.keywords]);

  useEffect(() => {
    if (isEdit) {
      setNavigateRoute("SANDBOX");
      setEditForm(true);
      typeof exploreDetail?.cover_img === "string" && setCoverImagePreview(exploreDetail?.cover_img);
      typeof exploreDetail?.cover_img === "object" && setCoverImagePreview(exploreDetail?.cover_img ? URL.createObjectURL(exploreDetail?.cover_img): "");
      setContentImagePreview(
        exploreDetail?.content_file ? exploreDetail?.content_file : ""
      );
    } else {
      setEditForm(false);
      setCoverImagePreview(
        exploreDetail?.cover_img ? URL.createObjectURL(exploreDetail?.cover_img) : ""
      );
      setContentImagePreview(
        exploreDetail?.content_file ? exploreDetail?.content_file : ""
      );
    }
  }, [exploreDetail]);

  useEffect(() => {    
    dispatch(activeExploreCategory());
  }, [dispatch]);

  useEffect(() => {
    if (exploreCategoryList?.category_list?.length) {
      setCategoryList(exploreCategoryList.category_list);
    }
  }, [exploreCategoryList]);

  const handleKeyPress1 = (event) => {
    if (event?.key == "Enter") {
      fileInputRef1?.current?.click();
    }
  };

  const handleKeyPress2 = (event) => {
    if (event?.key == "Enter") {
      fileInputRef2?.current?.click();
    }
  };

  const handleChangekeywordss = (e) => {
    if (e.target.checked && !keywordsValues?.includes(e.target.name)) {
      setkeywordsValues([...keywordsValues, e.target.name]);
      formik.setFieldValue("keywords", [...keywordsValues, e.target.name]);
    } else {
      setkeywordsValues([...keywordsValues.filter((x) => x !== e.target.name)]);
      formik.setFieldValue("keywords", [
        ...keywordsValues.filter((x) => x !== e.target.name),
      ]);
    }
  };

  const handleVideoFileChange = (e) => {
    const fileObj = e.target.files[0];
    if (fileObj.type === "video/mp4") {
      const video = document.createElement("video");
      video.preload = "metadata";
      video.onloadedmetadata = () => {
        URL.revokeObjectURL(video.src);
        formik.setFieldValue(
          "content_file_duration",
          Math.floor(video.duration)
        );
      };
      video.src = URL.createObjectURL(fileObj);
    } else {
      formik.setFieldValue("content_file_duration", null);
    }
  };

  return (
    <>
      <HelmetReact name="Explore Content" />
      <Box className="d-details-box">
        <Typography className="web-title">
          {editForm ? "UPDATE CONTENT" : "CREATE CONTENT"}
        </Typography>
        <Grid container spacing={2}>
          <Grid item lg={6} md={6} sm={6} xs={12}>
            <button className="back-btn" onClick={() => goBack()}>
              <ArrowBackIosIcon
                size="large"
                edge="start"
                sx={{
                  mr: 2,
                  color: "grey",
                  flexGrow: 0,
                  cursor: "pointer",
                  mb: 2,
                }}
              />
            </button>
          </Grid>
        </Grid>
        <Box>
          <Grid container spacing={2}>
            <Grid item lg={12} md={12} sm={12} xs={12}>
              <Box>
                <CustomTextField
                  fieldType="textInput"
                  label="Content title"
                  name="title"
                  required
                  fullWidth
                  value={formik.values.title}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  placeholder={"Enter Your Content title"}
                  error={
                    formik.touched.title && formik.errors.title
                      ? true
                      : false
                  }
                />
                {formik.touched.title && formik.errors.title && (
                  <FormHelperText className="error_message">
                    {formik.errors.title}
                  </FormHelperText>
                )}
              </Box>
            </Grid>
            <Grid item lg={12} md={12} sm={12} xs={12}>
              <Box>
                <CustomTextField
                  fieldType="textInput"
                  label="Contributor name"
                  name="contributor_name"
                  required
                  fullWidth
                  value={formik.values.contributor_name}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  placeholder={"Enter Your contributor name"}
                  error={
                    formik.touched.contributor_name &&
                      formik.errors.contributor_name
                      ? true
                      : false
                  }
                />
                {formik.touched.contributor_name &&
                  formik.errors.contributor_name && (
                    <FormHelperText className="error_message">
                      {formik.errors.contributor_name}
                    </FormHelperText>
                  )}
              </Box>
            </Grid>
            <Grid item lg={6} md={6} sm={6} xs={12}>
              <Box>
                <Grid item xs={12} sx={{ mb: 2 }}>
                  <FormLabel id="demo-controlled-radio-buttons-group">
                    Cover Image *
                  </FormLabel>
                  {formik.touched.cover_img && formik.errors.cover_img && (
                    <FormHelperText className="error_message">
                      {formik.errors.cover_img}
                    </FormHelperText>
                  )}
                </Grid>
                <Grid item xs={6}>
                  <Button
                    sx={{
                      background: "#000",
                      marginBottom: "15px",
                      borderRadius: "70px",
                    }}
                    variant="contained"
                    component="label"
                    onKeyDown={handleKeyPress1}
                    endIcon={<ArrowDropDownCircleIcon />}
                    className="program-cover-img-btn"
                  >
                    Select File
                    <input
                      name="cover_img"
                      accept="image/*"
                      id="contained-button-file"
                      type="file"
                      hidden
                      ref={fileInputRef1}
                      onChange={(e) => {
                        const fileReader = new FileReader();
                        fileReader.onload = () => {
                          formik.setTouched({
                            ...formik.touched.cover_img,
                            cover_img: true,
                          });
                          if (fileReader.readyState === 2) {
                            formik.setFieldValue(
                              "cover_img",
                              e.target.files[0]
                            );
                            setCoverImagePreview(fileReader.result);
                          }
                        };
                        e.target.files[0] &&
                          fileReader.readAsDataURL(e.target.files[0]);
                      }}
                    />
                  </Button>
                </Grid>
              </Box>
            </Grid>
            <Grid item xs={3}>
              <Typography>16:9</Typography>
              <img src={coverImagePreview} width="200px" height="70px" alt="" />
            </Grid>
            <Grid item xs={3}>
              <Typography>1:1</Typography>
              <img
                src={coverImagePreview}
                width="180px"
                height="150px"
                alt=""
              />
            </Grid>
            <Grid item lg={12} md={12} sm={12} xs={12}>
              <FormLabel id="demo-controlled-radio-buttons-group">
                Select Category *
              </FormLabel>
              <Box sx={{ marginTop: "10px" }}>
                <FormControl sx={{ m: 0, width: 300 }}>
                  <InputLabel id="demo-simple-select-label">
                    Category
                  </InputLabel>
                  <Select
                    MenuProps={MenuProps}
                    className="full-discription-text"
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    name="category"
                    value={formik.values.category}
                    label="Category"
                    onChange={formik.handleChange}
                  >
                    {categoryList?.map((category, index) => {
                      return (
                        <MenuItem key={index} value={category?.id}>
                          {category?.name}
                        </MenuItem>
                      );
                    })}
                  </Select>
                </FormControl>
                {formik.touched.category && formik.errors.category && (
                  <FormHelperText className="error_message">
                    {formik.errors.category}
                  </FormHelperText>
                )}
              </Box>
            </Grid>
            <Grid item lg={12} md={12} sm={12} xs={12}>
              <Box>
                <CustomTextField
                  fieldType="textInput"
                  label="Short description"
                  name="short_desc"
                  required
                  fullWidth
                  value={formik.values.short_desc}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  inputProps={{ maxLength: 130 }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment disableTypography position="end">
                        {`${formik.values.short_desc?.length}/130`}
                      </InputAdornment>
                    ),
                  }}
                  placeholder={"Enter Your short description"}
                  error={
                    formik.touched.short_desc &&
                      formik.errors.short_desc
                      ? true
                      : false
                  }
                />
                {formik.touched.short_desc &&
                  formik.errors.short_desc && (
                    <FormHelperText className="error_message">
                      {formik.errors.short_desc}
                    </FormHelperText>
                  )}
              </Box>
            </Grid>
            <Grid item lg={12} md={12} sm={12} xs={12}>
              <Box>
                <MyEditor
                  name="full_desc"
                  value={formik.values.full_desc}
                  onChange={(data) => {
                    formik.setFieldValue("full_desc", data);
                  }}
                />
                {formik.touched.full_desc &&
                  formik.errors.full_desc && (
                    <FormHelperText className="error_message">
                      {formik.errors.full_desc}
                    </FormHelperText>
                  )}
              </Box>
            </Grid>
            <Grid item lg={6} md={6} sm={6} xs={12}>
              <Box>
                <Grid item xs={12} sx={{ mb: 2 }}>
                  <FormLabel id="demo-controlled-radio-buttons-group">
                    Content file *
                  </FormLabel>
                  {formik.touched.content_file && formik.errors.content_file && (
                    <FormHelperText className="error_message">
                      {formik.errors.content_file}
                    </FormHelperText>
                  )}
                </Grid>
                <Grid item xs={6}>
                  <Button
                    variant="contained"
                    component="label"
                    onKeyDown={handleKeyPress2}
                    endIcon={<ArrowDropDownCircleIcon />}
                    className="program-cover-img-btn"
                  >
                    Select File
                    <input
                      name="content_file"
                      id="contained-button-file"
                      type="file"
                      hidden
                      ref={fileInputRef2}
                      onChange={(e) => {
                        formik.setTouched({
                          ...formik.touched.content_file,
                          content_file: true,
                        });
                        const fileReader = new FileReader();
                        fileReader.onload = () => {
                          if (fileReader.readyState === 2) {
                            handleVideoFileChange(e);
                            formik.setFieldValue(
                              "content_file",
                              e.target.files[0]
                            );
                            setContentImagePreview(e.target.files[0]);
                          }
                        };
                        e.target.files[0] &&
                          fileReader.readAsDataURL(e.target.files[0]);
                      }}
                    />
                  </Button>
                </Grid>
              </Box>
            </Grid>

            {isEdit == true &&
              typeof contentImagePreview === "string" &&
              (contentImagePreview.toLowerCase().endsWith(".mp4") ? (
                <Grid item xs={3}>
                  <iframe src={contentImagePreview} title="trailer" />
                </Grid>
              ) : (
                (contentImagePreview.toLowerCase().endsWith(".jpg") ||
                  contentImagePreview.toLowerCase().endsWith(".png") ||
                  contentImagePreview.toLowerCase().endsWith(".jpeg")) && (
                  <Grid item xs={3}>
                    <img
                      src={contentImagePreview}
                      alt=""
                      width="200px"
                      height="200px"
                    />
                  </Grid>
                )
              ))}

            {typeof formik?.values?.content_file == "object" &&
              formik?.values?.content_file?.type == "video/mp4" ? (
              <Grid item xs={3}>
                <iframe
                  src={URL.createObjectURL(formik?.values?.content_file)}
                  title="content_file"
                />
              </Grid>
            ) : formik.values?.content_file?.type == "image/jpg" ||
              formik.values?.content_file?.type == "image/jpeg" ||
              formik.values?.content_file?.type == "image/png" ? (
              <Grid item xs={3}>
                <img
                  src={URL.createObjectURL(formik.values?.content_file)}
                  alt=""
                  width="200px"
                  height="200px"
                />
              </Grid>
            ) : (
              ""
            )}

            <Grid item lg={12} md={12} sm={12} xs={12}>
              <FormLabel id="demo-controlled-radio-buttons-group">
                Enter keywords *
              </FormLabel>
              <Autocomplete
                sx={{ background: "white", mt: 2 }}
                multiple
                id="tags-outlined"
                options={[]}
                freeSolo
                fullWidth
                value={keywordsValues}
                onChange={handleOnChange}
                inputValue={inputValue}
                onInputChange={handleInputChange}
                renderTags={(value, getTagProps) =>
                  Array.isArray(value)
                    ? value.map((option, index) => (
                      <Chip
                        key={index}
                        label={option}
                        {...getTagProps({ index })}
                        onDelete={() => handleDelete(option)}
                      />
                    )) : null
                  }
                renderInput={(params) => (
                  <TextField
                    {...params}
                    placeholder="Enter  here"
                    onKeyDown={handleKeyPress}
                    error={
                      formik.touched.keywords && Boolean(formik.errors.keywords)
                    }
                  />
                )}
              />

              {formik.touched.keywords && formik.errors.keywords && (
                <FormHelperText className="error_message">
                  {typeof formik?.errors?.keywords !== "string"
                    ? formik?.errors?.keywords?.some((error) =>
                      error.includes("keywords")
                    )
                      ? "Empty keywords not valid"
                      : formik?.errors?.keywords
                    : formik?.errors?.keywords}
                </FormHelperText>
              )}
            </Grid>

            <Grid item xs={12} sx={{ textAlign: "end" }}>
              <Button
                sx={{
                  background: "#000",
                  borderRadius: "70px",
                }}
                variant="contained"
                className="next-btn"
                onClick={formik.handleSubmit}
              >
                {loading ? (
                  <Box>
                    <ReactLoading
                      type={"bubbles"}
                      height="30px"
                      width="30px"
                      color="#FFFFFF"
                    />
                  </Box>
                ) : !editForm ? (
                  "Preview"
                ) : (
                  "Update"
                )}
              </Button>
            </Grid>
          </Grid>
        </Box>
      </Box>
    </>
  );
};

export default CreateContent;
